export default __webpack_public_path__ + "d9f0d8933a020d72fcf8a66a0f251154.glb";